import { Component, ElementRef, OnDestroy, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SharedService } from './shared/shared.service';
import { FormService } from "./shared/form.service";
import { TranslateService } from "@ngx-translate/core";
import { ActivatedRoute, Router } from '@angular/router';
import { AEMConfiguration } from './interfaces/am-config.interface';
import { pushEvent } from '@allianz/tracking';
import { TrackService } from './services/track.service';

// Allianz AEM
import {
  EmbeddedDataModule,
  EmbeddedDataService,
  NORMALIZE_URL_SERVICE_CONFIG_TOKEN,
  NormalizeUrlModule,
  NormalizeUrlService
} from '@allianz/ngx-aem-integration'
import { TrackingPageService } from './services/trackPage.service';
import { LoadedFromCPService } from './shared/loaded-from-customer-portal.service';
import { LocalStorageService } from 'ngx-localstorage';

//

@Component({
  selector: 'seed-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {

  mainForm: FormGroup;
  pageId: string;
  currentPage;
  oldPage: string;
  oldPageName: string;
  currentPageName: string;

  constructor(public sharedService: SharedService,
    private router: Router,
    private route: ActivatedRoute,
    private elementRef: ElementRef,
    public translateService: TranslateService,
    public trackingPage: TrackingPageService,
    public formService: FormService,
    private chRef:ChangeDetectorRef,
    public trackService: TrackService,
    public localStorage: LocalStorageService,
    private loadedFromCPService: LoadedFromCPService,
    embeddedDataService: EmbeddedDataService<undefined, AEMConfiguration>) {

    this.trackService.init();
    console.log(embeddedDataService.ContextConfiguration);
    translateService.use((embeddedDataService.ContextConfiguration && embeddedDataService.ContextConfiguration.language) || 'bg');
    // translateService.onLangChange.subscribe(lang => {
    //   this.elementRef.nativeElement.style.removeProperty('--font-family');
    //   setTimeout(() => {
    //     // window['qbhome'].push({
    //     //   'pageInfo': {
    //     //     'name': 'language',
    //     //     'value': lang.lang
    //     //   }
    //     // });
    //     if (lang.lang === 'bg') {
    //       this.elementRef.nativeElement.style.setProperty('--font-family', '\'Monserrat\', sans-serif', 'important');
    //     } else {
    //       this.elementRef.nativeElement.style.setProperty('--font-family', '\'Allianz Neo\', sans-serif', 'important');
    //     }
    //   })
    // })
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      const id = params['id'];
      if(id==1){
        this.sharedService._isCustomerPortal=true
      } 
      else if (id==2)
      {
        this.sharedService._isAgentWebPage = true;

      } 
    })

    // let url = window.location.search;
    // if(url==='?id=1'){
    //   this.sharedService._isCustomerPortal=true
    // }
    // else if (url==='?id=2'){
    //   this.sharedService._isAgentWebPage = true;
    // }
    

    // setTimeout(() => {
    this.elementRef.nativeElement.parentNode.style.setProperty(
      '--font-family',
      "'Monserrat', sans-serif",
      'important'
    );
    this.translateService.onLangChange.subscribe((lang) => {
      this.elementRef.nativeElement.parentNode.style.removeProperty(
        '--font-family'
      );
      setTimeout(() => {
        if (lang.lang === 'bg') {
          this.elementRef.nativeElement.parentNode.style.setProperty(
            '--font-family',
            "'Monserrat', sans-serif",
            'important'
          );
        } else if (lang.lang === 'en') {
          this.elementRef.nativeElement.parentNode.style.setProperty(
            '--font-family',
            "'Allianz Neo', sans-serif",
            'important'
          );
          this.elementRef.nativeElement.parentNode.style.setProperty(
            '--button-small-font-size',
            '14px'
          );
        } else {
          this.elementRef.nativeElement.parentNode.style.setProperty(
            '--font-family',
            "'Monserrat', sans-serif",
            'important'
          );
        }
      });
    });

    this.route.queryParams.subscribe((params) => {
      const id = params['id'];
      const userInfo = params['userInfo'];
      const nIDAgent = params['nIDAgent']
      if(nIDAgent){
        this.formService.currentForm.controls.nIDAgent.patchValue(nIDAgent);
      }
      if (id == 1) {
        this.loadedFromCPService._isCustomerPortal = true;
        if(userInfo){
          this.loadedFromCPService.getUserInfo(userInfo);
          this.formService.currentForm.controls.nIDAgent.patchValue(nIDAgent);
        }
      }
    });

    this.router.events.subscribe((evt) => {
      if (document.querySelector('.root-element')) {
        document?.querySelector('.root-element')?.scrollTo(0, 0);
      }

    });
  }
  ngAfterViewChecked() {
    this.trackingPage.trackingPage(this.sharedService.sharedUrl)
    this.chRef.detectChanges();
  }

  ngOnDestroy() {
  }

  onActivate(event) {
    document?.querySelector('.root-element')?.scrollTo(0, 0)
    console.log('scroll');
  }
}
